// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
Category: #ffffff
Sub -category: #f5f5f5
Indicator: #ffffff
Sub-indicator: #e4e4e4
Sub-sub indicator: #f5f5f5



 */

.loadingSpinnerWrapper--Gdekv {
  height: 300px;
}

[dir] .quickActionButtonsWrapper--g5F8H {
  margin-top: 5px;
}

.divTable--z5mpQ {
  overflow: auto;
}

[dir] .divTable--z5mpQ {
  margin-bottom: 30px;
}

.tableMainHeading--u1dI0 {
  font-family: museo-sans;
  font-size: 16px;
  color: #000;
  font-weight: 500;
  line-height: 1.4;
}

[dir] .tableMainHeading--u1dI0 {
  margin: 25px 0 15px 0;
}

.tableScroll--ALljR {
  overflow-x: auto;
}

[dir] .mifComparisonCable--SGqWc {
  border-bottom: 1px solid rgba(184, 184, 184, 0.3);
}

[dir=ltr] .mifComparisonCable--SGqWc {
  border-right: 1px solid rgba(184, 184, 184, 0.3);
}

[dir=rtl] .mifComparisonCable--SGqWc {
  border-left: 1px solid rgba(184, 184, 184, 0.3);
}

[dir=ltr] .tblComparison--h_GQs td + td {
  border-left: 1px dashed #b8b8b8;
}

[dir=rtl] .tblComparison--h_GQs td + td {
  border-right: 1px dashed #b8b8b8;
}

.heading--F6f9D {
  min-height: 35px;
  font-size: 14px;
  width: 16rem;
  display: flex;
  align-items: center;
}

[dir] .heading--F6f9D {
  padding: 0;
}

[dir=ltr] .heading--F6f9D {
  border-left: 1px solid rgba(184, 184, 184, 0.3);
}

[dir=rtl] .heading--F6f9D {
  border-right: 1px solid rgba(184, 184, 184, 0.3);
}

[dir] .quickActionsWrapper--QE5HH {
  margin-bottom: 5px;
}

[dir=ltr] .quickActionsWrapper--QE5HH {
  text-align: left;
}

[dir=rtl] .quickActionsWrapper--QE5HH {
  text-align: right;
}

[dir] .quickActionButton--TawzE {
  cursor: pointer;
}

.quickActionButton--TawzE:hover {
  text-decoration: underline;
}

[dir] .quickActionSeparator--iuI6R {
  margin: 0 5px;
}

.measureIconWrapper--OetTG {
  width: 1.4rem;
  position: relative;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  pointer-events: none;
}

.measureIcon--XMoG8 {
  position: absolute;
  top: -10px;
  width: 20px;
  height: 20px;
}

[dir] .measureIcon--XMoG8 {
  background-repeat: no-repeat;
}

[dir=ltr] .measureIcon--XMoG8 {
  left: 5px;
}

[dir=rtl] .measureIcon--XMoG8 {
  right: 5px;
}

.infoIcon--Ew0u9 {
  width: 17px;
  height: 17px;
}

[dir] .infoIcon--Ew0u9 {
  margin-top: 1px;
}

.classificationInfoIcon--tgrOa {
  width: 14px;
  height: 14px;
  color: #333333;
}

[dir=ltr] .classificationInfoIcon--tgrOa {
  margin-left: 5px;
}

[dir=rtl] .classificationInfoIcon--tgrOa {
  margin-right: 5px;
}

.sortBy--mFTjB .classificationInfoIcon--tgrOa {
  color: #fff;
}

.boldTableRow--XsnU5 h4,
.boldTableRow--XsnU5 td {
  font-weight: 900 !important;
}

.rowTitle--PvCms {
  flex: 1;
  white-space: break-spaces;
  font-size: 14px;
}

[dir] .rowTitle--PvCms {
  margin-bottom: 0;
  padding-top: 5px;
  padding-bottom: 5px;
}

[dir=ltr] .rowTitle--PvCms {
  text-align: left;
  padding-left: 10px;
}

[dir=rtl] .rowTitle--PvCms {
  text-align: right;
  padding-right: 10px;
}

.locationTitle1--qha5H {
  width: 15rem;
  font-size: 15px;
}

.locationTitle2--ocwZp {
  width: 15rem;
  font-size: 15px;
}

[dir=ltr] .locationTitle2--ocwZp {
  padding-left: 15px;
}

[dir=rtl] .locationTitle2--ocwZp {
  padding-right: 15px;
}

.tableHeaderRow--G9JkI {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.rowActionsWrapper--gR48Z {
  display: flex;
  justify-content: flex-end;
  color: #000;
  min-width: 45px;
  /*user-select: none;*/
  /*pointer-events: none;*/
}

.expandIcon--E90Jl {
  color: #000;
  min-width: 20px;
}

[dir=ltr] .expandIcon--E90Jl {
  margin-right: 5px;
}

[dir=rtl] .expandIcon--E90Jl {
  margin-left: 5px;
}

.comparisonTableHeader--AsIVZ {
  font-family: var(--base-font);
  font-weight: 300;
  font-size: 15px;
  color: #000;
  height: 55px;
  position: relative;
}

[dir] .comparisonTableHeader--AsIVZ {
  background: #ececec;
  padding: 5px;
}

.comparisonTableHeader--AsIVZ:first-child {
  text-transform: uppercase;
  width: 16.5rem;
}

[dir=ltr] .comparisonTableHeader--AsIVZ:first-child {
  padding-left: 15px;
  text-align: left;
}

[dir=rtl] .comparisonTableHeader--AsIVZ:first-child {
  padding-right: 15px;
  text-align: right;
}

[dir] .recordCell--TDIYg {
  padding: 2px;
  cursor: pointer;
}

[dir] .highLowCell--ndYjV {
  background: white;
  border: 1px white solid;
}

[dir] .highlightedCell--k5MN9 {
  background-color: rgba(199, 252, 255, 1);
}

[dir] .highlightedCell--k5MN9 .highLowCell--ndYjV {
  background-color: rgba(199, 252, 255, 1);
  border-color: rgba(199, 252, 255, 1);
}

.sortBy--mFTjB {
  color: #fff;
}

[dir] .sortBy--mFTjB {
  background: #333;
}

.annualHeaderTitle--LPupg {
  display: inline;
}

.descArrow--ZYzdV,
.ascArrow--OPtIU {
  position: relative;
}

[dir] .descArrow--ZYzdV, [dir] .ascArrow--OPtIU {
  text-align: center;
}

[dir=ltr] .descArrow--ZYzdV, [dir=ltr] .ascArrow--OPtIU {
  padding-right: 10px;
}

[dir=rtl] .descArrow--ZYzdV, [dir=rtl] .ascArrow--OPtIU {
  padding-left: 10px;
}

.descArrow--ZYzdV:after,
.ascArrow--OPtIU:after {
  display: block;
  position: absolute;
  top: 50%;
}

[dir] .descArrow--ZYzdV:after, [dir] .ascArrow--OPtIU:after {
  margin-top: -11px;
}

[dir=ltr] .descArrow--ZYzdV:after, [dir=ltr] .ascArrow--OPtIU:after {
  right: 2px;
}

[dir=rtl] .descArrow--ZYzdV:after, [dir=rtl] .ascArrow--OPtIU:after {
  left: 2px;
}
.descArrow--ZYzdV:after {
  content: '\\f0d7';
  font-family: 'FontAwesome';
}

.ascArrow--OPtIU:after {
  content: '\\f0d8';
  font-family: 'FontAwesome';
}

.negativeFieldNumber--NF2sC {
  color: #df1b12;
}

.positiveFieldNumber--rjXd9 {
  color: #657a2a;
}

.clasificationColumn--R_Jy8 {
  width: 280px;
  min-width: 240px;
}

.IncreasingImprovement--i5Twf {
  color: white;
}

[dir] .IncreasingImprovement--i5Twf {
  background-color: #418a8f;
}

[dir] .SlowingImprovement--Yd3Ct {
  background-color: #89a361;
}

[dir] .WarningSigns--DjGIX {
  background-color: #c5b300;
}

[dir] .BouncingBack--QwyD4 {
  background-color: #ffd500;
}

[dir] .SlowingDeterioration--LPRpQ {
  background-color: #ee7330;
}

.IncreasingDeterioration--Ml3F5 {
  color: white;
}

[dir] .IncreasingDeterioration--Ml3F5 {
  background-color: #b1302e;
}

[dir] .highestValue--ptVav {
  background-clip: content-box;
  background-color: #d1df12 !important;
}

.lowestValue--uixng {
  color: white;
}

[dir] .lowestValue--uixng {
  background-clip: content-box;
  background-color: #df1258 !important;
}

.inverted--GqZ0X .highestValue--ptVav {
  color: white;
}

[dir] .inverted--GqZ0X .highestValue--ptVav {
  background-color: #df1258 !important;
}

.inverted--GqZ0X .lowestValue--uixng {
  color: black;
}

[dir] .inverted--GqZ0X .lowestValue--uixng {
  background-color: #d1df12 !important;
}

[dir] .borderCell--Q62oR {
  padding: 3px;
}

[dir] .trimmed--hvdHp {
  background: rgb(172, 172, 172);
}

[dir] .estimated--qIipi {
  background: rgb(166, 158, 76);
}

[dir] .trimmedEstimated--nzqaA {
  background: rgb(29, 90, 119);
}

.row--aRe7s {
  position: relative;
}

.separatorSpan--_n_b2 {
  min-width: 10px;
  height: 100%;
  position: absolute;
  top: 0;
}

[dir=ltr] .separatorSpan1--WxD8C {
  left: 0;
  border-left: rgba(184, 184, 184, 0.3) 1px solid;
}

[dir=rtl] .separatorSpan1--WxD8C {
  right: 0;
  border-right: rgba(184, 184, 184, 0.3) 1px solid;
}

.separatorSpan2--GmniL {
  min-width: 15px;
}

[dir=ltr] .separatorSpan2--GmniL {
  left: 10px;
}

[dir=rtl] .separatorSpan2--GmniL {
  right: 10px;
}

.separatorSpan3--YfIVD {
  min-width: 15px;
}

[dir=ltr] .separatorSpan3--YfIVD {
  left: 25px;
}

[dir=rtl] .separatorSpan3--YfIVD {
  right: 25px;
}

.separatorSpan4--ftgJo {
  min-width: 15px;
}

[dir=ltr] .separatorSpan4--ftgJo {
  left: 40px;
}

[dir=rtl] .separatorSpan4--ftgJo {
  right: 40px;
}

.separatorSpan5--M2ySB {
  min-width: 15px;
}

[dir=ltr] .separatorSpan5--M2ySB {
  left: 55px;
}

[dir=rtl] .separatorSpan5--M2ySB {
  right: 55px;
}

[dir] .rowMeasureLevel1--Jisi7 {
  background-color: #fff;
}

[dir] .rowMeasureLevel2--myyFv {
  background-color: #f5f5f5;
}

[dir] .rowMeasureLevel3--Bxzcz {
  background-color: #e4e4e4;
}

[dir] .rowMeasureLevel4--DYy8M {
  background-color: #fff;
}
[dir] .rowMeasureLevel5--g8nZm {
  background-color: #f5f5f5;
}

[dir] .rowMeasureLevel6--GWkAc {
  background-color: #e4e4e4;
}

[dir=ltr] .rowMeasureLevel2--myyFv .heading--F6f9D {
  padding-left: 10px;
}

[dir=rtl] .rowMeasureLevel2--myyFv .heading--F6f9D {
  padding-right: 10px;
}

[dir=ltr] .rowMeasureLevel3--Bxzcz .heading--F6f9D {
  padding-left: 30px;
}

[dir=rtl] .rowMeasureLevel3--Bxzcz .heading--F6f9D {
  padding-right: 30px;
}

[dir=ltr] .rowMeasureLevel4--DYy8M .heading--F6f9D {
  padding-left: 40px;
}

[dir=rtl] .rowMeasureLevel4--DYy8M .heading--F6f9D {
  padding-right: 40px;
}

[dir=ltr] .rowMeasureLevel5--g8nZm .heading--F6f9D {
  padding-left: 50px;
}

[dir=rtl] .rowMeasureLevel5--g8nZm .heading--F6f9D {
  padding-right: 50px;
}

[dir=ltr] .rowMeasureLevel6--GWkAc .heading--F6f9D {
  padding-left: 60px;
}

[dir=rtl] .rowMeasureLevel6--GWkAc .heading--F6f9D {
  padding-right: 60px;
}

.textStyling0--OroLS,
.textStyling1--oaLeF {
  text-transform: uppercase;
}

.textStyling2--VPVru {
  text-transform: capitalize;
}

.textStyling3--GedP0,
.textStyling4--xPRsi,
.textStyling5--cxAKf {
  font-style: italic;
  position: relative;
}

.textStyling4--xPRsi:before,
.textStyling5--cxAKf:before {
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

[dir=ltr] .textStyling4--xPRsi:before, [dir=ltr] .textStyling5--cxAKf:before {
  left: -13px;
}

[dir=rtl] .textStyling4--xPRsi:before, [dir=rtl] .textStyling5--cxAKf:before {
  right: -13px;
}

.textStyling4--xPRsi:before {
  content: '-';
  width: 5px;
}

.textStyling5--cxAKf:before {
  content: '--';
  width: 15px;
}

#screenshotPdfFrame .quickActionsWrapper--QE5HH,
#screenshotPdfFrame .tableMainHeading--u1dI0,
#screenshotPdfFrame .rowActionsWrapper--gR48Z {
  display: none;
}

[dir=ltr] .highlightedCountry--Cq63u {
  border-left: 4px solid #04febb;
}

[dir=rtl] .highlightedCountry--Cq63u {
  border-right: 4px solid #04febb;
}

.significantImprovement--NnlXJ {
  /*color: #000;*/
}

[dir] .significantImprovement--NnlXJ {
  background-color: rgb(206, 224, 174);
}

.significantDeterioration--GJJFe {
  /*color: #fff;*/
}

[dir] .significantDeterioration--GJJFe {
  background-color: rgb(215, 152, 153);
}

.significantImprovement--NnlXJ td h4 div,
.significantImprovement--NnlXJ td div div,
.significantDeterioration--GJJFe td h4 div,
.significantDeterioration--GJJFe td div div {
  width: -moz-fit-content;
  width: fit-content;
}

[dir] .significantImprovement--NnlXJ td h4 div, [dir] .significantImprovement--NnlXJ td div div, [dir] .significantDeterioration--GJJFe td h4 div, [dir] .significantDeterioration--GJJFe td div div {
  padding: 0 3px;
  background: white;
}

.annualCellValue--D5jT0 {
  width: -moz-fit-content;
  width: fit-content;
}

[dir] .annualCellValue--D5jT0 {
  padding: 0 3px;
  margin: 0 auto;
  background: white;
}

.annualCellValueNoBackground--Fnun0 {
  width: -moz-fit-content;
  width: fit-content;
}

[dir] .annualCellValueNoBackground--Fnun0 {
  padding: 0 3px;
  margin: 0 auto;
}

[dir] .significantImprovement--NnlXJ td div div, [dir] .significantDeterioration--GJJFe td div div {
  margin: 0 auto;
}

.significantChangesTable--bfxAl .measureLevel2--m_LVu,
.significantChangesTable--bfxAl .measureLevel3--iKcNx,
.significantChangesTable--bfxAl .measureLevel4--i6laD,
.significantChangesTable--bfxAl .measureLevel5--ZBfay,
.significantChangesTable--bfxAl .measureLevel6--ulODq {
  opacity: 0.3;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/DataTable/styles.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;;AAEF;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAEhB;;AAHA;EAEE,mBAAmB;AACrB;;AAKA;EAEE,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAPA;EACE,qBAAqB;AAMvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;AAEnD;;AAHA;EAEE,gDAAgD;AAClD;;AAHA;EAEE,+CAAgD;AAClD;;AAEA;EACE,+BAA+B;AACjC;;AAFA;EACE,gCAA+B;AACjC;;AAKA;EAEE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;AAErB;;AARA;EACE,UAAU;AAOZ;;AARA;EAOE,+CAA+C;AACjD;;AARA;EAOE,gDAA+C;AACjD;;AAEA;EAEE,kBAAkB;AACpB;;AAHA;EACE,gBAAgB;AAElB;;AAHA;EACE,iBAAgB;AAElB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EAEV,WAAW;EACX,YAAY;AAEd;;AAPA;EAME,4BAA4B;AAC9B;;AAPA;EAGE,SAAS;AAIX;;AAPA;EAGE,UAAS;AAIX;;AAEA;EAEE,WAAW;EACX,YAAY;AACd;;AAJA;EACE,eAAe;AAGjB;;AAEA;EACE,WAAW;EACX,YAAY;EAEZ,cAAc;AAChB;;AALA;EAGE,gBAAgB;AAElB;;AALA;EAGE,iBAAgB;AAElB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EAEP,yBAAyB;EAEzB,eAAe;AAIjB;;AATA;EAIE,gBAAgB;EAGhB,gBAAgB;EAChB,mBAAmB;AACrB;;AATA;EAEE,gBAAgB;EAIhB,kBAAkB;AAGpB;;AATA;EAEE,iBAAgB;EAIhB,mBAAkB;AAGpB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EAEE,YAAY;EACZ,eAAe;AACjB;;AAJA;EACE,kBAAkB;AAGpB;;AAJA;EACE,mBAAkB;AAGpB;;AAEA;EACE,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EAEE,WAAW;EACX,eAAe;AACjB;;AAJA;EACE,iBAAiB;AAGnB;;AAJA;EACE,gBAAiB;AAGnB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,WAAW;EAGX,YAAY;EACZ,kBAAkB;AACpB;;AATA;EAKE,mBAAmB;EACnB,YAAY;AAGd;;AAEA;EACE,yBAAyB;EAGzB,cAAc;AAChB;;AALA;EAEE,kBAAkB;EAClB,gBAAgB;AAElB;;AALA;EAEE,mBAAkB;EAClB,iBAAgB;AAElB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EAEE,WAAW;AACb;;AAHA;EACE,gBAAgB;AAElB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AAGpB;;AALA;EAIE,kBAAkB;AACpB;;AALA;EAGE,mBAAmB;AAErB;;AALA;EAGE,kBAAmB;AAErB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,QAAQ;AAGV;;AAPA;EAME,iBAAiB;AACnB;;AAPA;EAKE,UAAU;AAEZ;;AAPA;EAKE,SAAU;AAEZ;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EAEE,YAAY;AACd;;AAHA;EACE,yBAAyB;AAE3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAEE,YAAY;AACd;;AAHA;EACE,yBAAyB;AAE3B;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EAGE,YAAY;AACd;;AAJA;EACE,4BAA4B;EAC5B,oCAAoC;AAEtC;;AAEA;EAEE,YAAY;AACd;;AAHA;EACE,oCAAoC;AAEtC;;AAEA;EAEE,YAAY;AACd;;AAHA;EACE,oCAAoC;AAEtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,OAAO;EACP,+CAA+C;AACjD;;AAHA;EACE,QAAO;EACP,gDAA+C;AACjD;;AAEA;EAEE,eAAe;AACjB;;AAHA;EACE,UAAU;AAEZ;;AAHA;EACE,WAAU;AAEZ;;AAEA;EAEE,eAAe;AACjB;;AAHA;EACE,UAAU;AAEZ;;AAHA;EACE,WAAU;AAEZ;;AAEA;EAEE,eAAe;AACjB;;AAHA;EACE,UAAU;AAEZ;;AAHA;EACE,WAAU;AAEZ;;AAEA;EAEE,eAAe;AACjB;;AAHA;EACE,UAAU;AAEZ;;AAHA;EACE,WAAU;AAEZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAeA;EACE,kBAAkB;AACpB;;AAFA;EACE,mBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAFA;EACE,mBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAFA;EACE,mBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAFA;EACE,mBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAFA;EACE,mBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAElB,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AATA;EAGE,WAAW;AAMb;;AATA;EAGE,YAAW;AAMb;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAFA;EACE,+BAA8B;AAChC;;AAEA;EAEE,eAAe;AACjB;;AAHA;EACE,oCAAoC;AAEtC;;AAEA;EAEE,eAAe;AACjB;;AAHA;EACE,oCAAoC;AAEtC;;AAEA;;;;EAIE,uBAAkB;EAAlB,kBAAkB;AAGpB;;AAPA;EAKE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;AAIpB;;AALA;EAEE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;AAGpB;;AAJA;EAEE,cAAc;EACd,cAAc;AAChB;;AAEA;EAEE,cAAc;AAChB;;AAEA;;;;;EAKE,YAAY;AACd","sourcesContent":["/**\nCategory: #ffffff\nSub -category: #f5f5f5\nIndicator: #ffffff\nSub-indicator: #e4e4e4\nSub-sub indicator: #f5f5f5\n\n\n\n */\n\n.loadingSpinnerWrapper {\n  height: 300px;\n}\n\n.quickActionButtonsWrapper {\n  margin-top: 5px;\n}\n\n.divTable {\n  overflow: auto;\n  margin-bottom: 30px;\n}\n\n.significantChangesTable {\n}\n\n.tableMainHeading {\n  margin: 25px 0 15px 0;\n  font-family: museo-sans;\n  font-size: 16px;\n  color: #000;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.tableScroll {\n  overflow-x: auto;\n}\n\n.mifComparisonCable {\n  border-bottom: 1px solid rgba(184, 184, 184, 0.3);\n  border-right: 1px solid rgba(184, 184, 184, 0.3);\n}\n\n.tblComparison td + td {\n  border-left: 1px dashed #b8b8b8;\n}\n\n.mifComparisonCable th {\n}\n\n.heading {\n  padding: 0;\n  min-height: 35px;\n  font-size: 14px;\n  width: 16rem;\n  display: flex;\n  align-items: center;\n  border-left: 1px solid rgba(184, 184, 184, 0.3);\n}\n\n.quickActionsWrapper {\n  text-align: left;\n  margin-bottom: 5px;\n}\n\n.quickActionButton {\n  cursor: pointer;\n}\n\n.quickActionButton:hover {\n  text-decoration: underline;\n}\n\n.quickActionSeparator {\n  margin: 0 5px;\n}\n\n.measureIconWrapper {\n  width: 1.4rem;\n  position: relative;\n  user-select: none;\n  pointer-events: none;\n}\n\n.measureIcon {\n  position: absolute;\n  top: -10px;\n  left: 5px;\n  width: 20px;\n  height: 20px;\n  background-repeat: no-repeat;\n}\n\n.infoIcon {\n  margin-top: 1px;\n  width: 17px;\n  height: 17px;\n}\n\n.classificationInfoIcon {\n  width: 14px;\n  height: 14px;\n  margin-left: 5px;\n  color: #333333;\n}\n\n.sortBy .classificationInfoIcon {\n  color: #fff;\n}\n\n.boldTableRow h4,\n.boldTableRow td {\n  font-weight: 900 !important;\n}\n\n.rowTitle {\n  flex: 1;\n  text-align: left;\n  white-space: break-spaces;\n  margin-bottom: 0;\n  font-size: 14px;\n  padding-left: 10px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.locationTitle1 {\n  width: 15rem;\n  font-size: 15px;\n}\n\n.locationTitle2 {\n  padding-left: 15px;\n  width: 15rem;\n  font-size: 15px;\n}\n\n.tableHeaderRow {\n  user-select: none;\n}\n\n.rowActionsWrapper {\n  display: flex;\n  justify-content: flex-end;\n  color: #000;\n  min-width: 45px;\n  /*user-select: none;*/\n  /*pointer-events: none;*/\n}\n\n.expandIcon {\n  margin-right: 5px;\n  color: #000;\n  min-width: 20px;\n}\n\n.comparisonTableHeader {\n  font-family: var(--base-font);\n  font-weight: 300;\n  font-size: 15px;\n  color: #000;\n  background: #ececec;\n  padding: 5px;\n  height: 55px;\n  position: relative;\n}\n\n.comparisonTableHeader:first-child {\n  text-transform: uppercase;\n  padding-left: 15px;\n  text-align: left;\n  width: 16.5rem;\n}\n\n.recordCell {\n  padding: 2px;\n  cursor: pointer;\n}\n\n.highLowCell {\n  background: white;\n  border: 1px white solid;\n}\n\n.highlightedCell {\n  background-color: rgba(199, 252, 255, 1);\n}\n\n.highlightedCell .highLowCell {\n  background-color: rgba(199, 252, 255, 1);\n  border-color: rgba(199, 252, 255, 1);\n}\n\n.sortBy {\n  background: #333;\n  color: #fff;\n}\n\n.annualHeaderTitle {\n  display: inline;\n}\n\n.descArrow,\n.ascArrow {\n  position: relative;\n  padding-right: 10px;\n  text-align: center;\n}\n\n.descArrow:after,\n.ascArrow:after {\n  display: block;\n  position: absolute;\n  top: 50%;\n  right: 2px;\n  margin-top: -11px;\n}\n.descArrow:after {\n  content: '\\f0d7';\n  font-family: 'FontAwesome';\n}\n\n.ascArrow:after {\n  content: '\\f0d8';\n  font-family: 'FontAwesome';\n}\n\n.negativeFieldNumber {\n  color: #df1b12;\n}\n\n.positiveFieldNumber {\n  color: #657a2a;\n}\n\n.clasificationColumn {\n  width: 280px;\n  min-width: 240px;\n}\n\n.IncreasingImprovement {\n  background-color: #418a8f;\n  color: white;\n}\n\n.SlowingImprovement {\n  background-color: #89a361;\n}\n\n.WarningSigns {\n  background-color: #c5b300;\n}\n\n.BouncingBack {\n  background-color: #ffd500;\n}\n\n.SlowingDeterioration {\n  background-color: #ee7330;\n}\n\n.IncreasingDeterioration {\n  background-color: #b1302e;\n  color: white;\n}\n\n.highestValue {\n  background-clip: content-box;\n  background-color: #d1df12 !important;\n}\n\n.lowestValue {\n  background-clip: content-box;\n  background-color: #df1258 !important;\n  color: white;\n}\n\n.inverted .highestValue {\n  background-color: #df1258 !important;\n  color: white;\n}\n\n.inverted .lowestValue {\n  background-color: #d1df12 !important;\n  color: black;\n}\n\n.borderCell {\n  padding: 3px;\n}\n\n.trimmed {\n  background: rgb(172, 172, 172);\n}\n\n.estimated {\n  background: rgb(166, 158, 76);\n}\n\n.trimmedEstimated {\n  background: rgb(29, 90, 119);\n}\n\n.row {\n  position: relative;\n}\n\n.separatorSpan {\n  min-width: 10px;\n  height: 100%;\n  position: absolute;\n  top: 0;\n}\n\n.separatorSpan1 {\n  left: 0;\n  border-left: rgba(184, 184, 184, 0.3) 1px solid;\n}\n\n.separatorSpan2 {\n  left: 10px;\n  min-width: 15px;\n}\n\n.separatorSpan3 {\n  left: 25px;\n  min-width: 15px;\n}\n\n.separatorSpan4 {\n  left: 40px;\n  min-width: 15px;\n}\n\n.separatorSpan5 {\n  left: 55px;\n  min-width: 15px;\n}\n\n.rowMeasureLevel1 {\n  background-color: #fff;\n}\n\n.rowMeasureLevel2 {\n  background-color: #f5f5f5;\n}\n\n.rowMeasureLevel3 {\n  background-color: #e4e4e4;\n}\n\n.rowMeasureLevel4 {\n  background-color: #fff;\n}\n.rowMeasureLevel5 {\n  background-color: #f5f5f5;\n}\n\n.rowMeasureLevel6 {\n  background-color: #e4e4e4;\n}\n\n.measureLevel1 {\n}\n.measureLevel2 {\n}\n.measureLevel3 {\n}\n.measureLevel4 {\n}\n.measureLevel5 {\n}\n.measureLevel6 {\n}\n\n.rowMeasureLevel2 .heading {\n  padding-left: 10px;\n}\n\n.rowMeasureLevel3 .heading {\n  padding-left: 30px;\n}\n\n.rowMeasureLevel4 .heading {\n  padding-left: 40px;\n}\n\n.rowMeasureLevel5 .heading {\n  padding-left: 50px;\n}\n\n.rowMeasureLevel6 .heading {\n  padding-left: 60px;\n}\n\n.textStyling0,\n.textStyling1 {\n  text-transform: uppercase;\n}\n\n.textStyling2 {\n  text-transform: capitalize;\n}\n\n.textStyling3,\n.textStyling4,\n.textStyling5 {\n  font-style: italic;\n  position: relative;\n}\n\n.textStyling4:before,\n.textStyling5:before {\n  position: absolute;\n  left: -13px;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.textStyling4:before {\n  content: '-';\n  width: 5px;\n}\n\n.textStyling5:before {\n  content: '--';\n  width: 15px;\n}\n\n:global(#screenshotPdfFrame) .quickActionsWrapper,\n:global(#screenshotPdfFrame) .tableMainHeading,\n:global(#screenshotPdfFrame) .rowActionsWrapper {\n  display: none;\n}\n\n.highlightedCountry {\n  border-left: 4px solid #04febb;\n}\n\n.significantImprovement {\n  background-color: rgb(206, 224, 174);\n  /*color: #000;*/\n}\n\n.significantDeterioration {\n  background-color: rgb(215, 152, 153);\n  /*color: #fff;*/\n}\n\n.significantImprovement td h4 div,\n.significantImprovement td div div,\n.significantDeterioration td h4 div,\n.significantDeterioration td div div {\n  width: fit-content;\n  padding: 0 3px;\n  background: white;\n}\n\n.annualCellValue {\n  width: fit-content;\n  padding: 0 3px;\n  margin: 0 auto;\n  background: white;\n}\n\n.annualCellValueNoBackground {\n  width: fit-content;\n  padding: 0 3px;\n  margin: 0 auto;\n}\n\n.significantImprovement td div div,\n.significantDeterioration td div div {\n  margin: 0 auto;\n}\n\n.significantChangesTable .measureLevel2,\n.significantChangesTable .measureLevel3,\n.significantChangesTable .measureLevel4,\n.significantChangesTable .measureLevel5,\n.significantChangesTable .measureLevel6 {\n  opacity: 0.3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingSpinnerWrapper": `loadingSpinnerWrapper--Gdekv`,
	"quickActionButtonsWrapper": `quickActionButtonsWrapper--g5F8H`,
	"divTable": `divTable--z5mpQ`,
	"tableMainHeading": `tableMainHeading--u1dI0`,
	"tableScroll": `tableScroll--ALljR`,
	"mifComparisonCable": `mifComparisonCable--SGqWc`,
	"tblComparison": `tblComparison--h_GQs`,
	"heading": `heading--F6f9D`,
	"quickActionsWrapper": `quickActionsWrapper--QE5HH`,
	"quickActionButton": `quickActionButton--TawzE`,
	"quickActionSeparator": `quickActionSeparator--iuI6R`,
	"measureIconWrapper": `measureIconWrapper--OetTG`,
	"measureIcon": `measureIcon--XMoG8`,
	"infoIcon": `infoIcon--Ew0u9`,
	"classificationInfoIcon": `classificationInfoIcon--tgrOa`,
	"sortBy": `sortBy--mFTjB`,
	"boldTableRow": `boldTableRow--XsnU5`,
	"rowTitle": `rowTitle--PvCms`,
	"locationTitle1": `locationTitle1--qha5H`,
	"locationTitle2": `locationTitle2--ocwZp`,
	"tableHeaderRow": `tableHeaderRow--G9JkI`,
	"rowActionsWrapper": `rowActionsWrapper--gR48Z`,
	"expandIcon": `expandIcon--E90Jl`,
	"comparisonTableHeader": `comparisonTableHeader--AsIVZ`,
	"recordCell": `recordCell--TDIYg`,
	"highLowCell": `highLowCell--ndYjV`,
	"highlightedCell": `highlightedCell--k5MN9`,
	"annualHeaderTitle": `annualHeaderTitle--LPupg`,
	"descArrow": `descArrow--ZYzdV`,
	"ascArrow": `ascArrow--OPtIU`,
	"negativeFieldNumber": `negativeFieldNumber--NF2sC`,
	"positiveFieldNumber": `positiveFieldNumber--rjXd9`,
	"clasificationColumn": `clasificationColumn--R_Jy8`,
	"IncreasingImprovement": `IncreasingImprovement--i5Twf`,
	"SlowingImprovement": `SlowingImprovement--Yd3Ct`,
	"WarningSigns": `WarningSigns--DjGIX`,
	"BouncingBack": `BouncingBack--QwyD4`,
	"SlowingDeterioration": `SlowingDeterioration--LPRpQ`,
	"IncreasingDeterioration": `IncreasingDeterioration--Ml3F5`,
	"highestValue": `highestValue--ptVav`,
	"lowestValue": `lowestValue--uixng`,
	"inverted": `inverted--GqZ0X`,
	"borderCell": `borderCell--Q62oR`,
	"trimmed": `trimmed--hvdHp`,
	"estimated": `estimated--qIipi`,
	"trimmedEstimated": `trimmedEstimated--nzqaA`,
	"row": `row--aRe7s`,
	"separatorSpan": `separatorSpan--_n_b2`,
	"separatorSpan1": `separatorSpan1--WxD8C`,
	"separatorSpan2": `separatorSpan2--GmniL`,
	"separatorSpan3": `separatorSpan3--YfIVD`,
	"separatorSpan4": `separatorSpan4--ftgJo`,
	"separatorSpan5": `separatorSpan5--M2ySB`,
	"rowMeasureLevel1": `rowMeasureLevel1--Jisi7`,
	"rowMeasureLevel2": `rowMeasureLevel2--myyFv`,
	"rowMeasureLevel3": `rowMeasureLevel3--Bxzcz`,
	"rowMeasureLevel4": `rowMeasureLevel4--DYy8M`,
	"rowMeasureLevel5": `rowMeasureLevel5--g8nZm`,
	"rowMeasureLevel6": `rowMeasureLevel6--GWkAc`,
	"textStyling0": `textStyling0--OroLS`,
	"textStyling1": `textStyling1--oaLeF`,
	"textStyling2": `textStyling2--VPVru`,
	"textStyling3": `textStyling3--GedP0`,
	"textStyling4": `textStyling4--xPRsi`,
	"textStyling5": `textStyling5--cxAKf`,
	"highlightedCountry": `highlightedCountry--Cq63u`,
	"significantImprovement": `significantImprovement--NnlXJ`,
	"significantDeterioration": `significantDeterioration--GJJFe`,
	"annualCellValue": `annualCellValue--D5jT0`,
	"annualCellValueNoBackground": `annualCellValueNoBackground--Fnun0`,
	"significantChangesTable": `significantChangesTable--bfxAl`,
	"measureLevel2": `measureLevel2--m_LVu`,
	"measureLevel3": `measureLevel3--iKcNx`,
	"measureLevel4": `measureLevel4--i6laD`,
	"measureLevel5": `measureLevel5--ZBfay`,
	"measureLevel6": `measureLevel6--ulODq`
};
export default ___CSS_LOADER_EXPORT___;
